//
//
//
//
//
//
export default {
  props: {
    editButtons: {
      type: Array,
      required: true
    }
  },
  computed: {
    // This needs to be computed so that it is always up-to-date, regardless of whether:
    // 1. The page is navigated away and the parent component gets reused or
    // 2. There is just a delay in the initialization of the menu variable in ($ready())
    editMenu: function editMenu() {
      if (this.editButtons.length > 0) {
        return {
          icon: {
            material: {
              name: "more_vert"
            }
          },
          childButtons: this.editButtons
        };
      } else {
        return null;
      }
    }
  },
  methods: {
    buttonSpec: function buttonSpec(item) {
      return Object.assign({}, item, {
        view: "button-v1",
        styleClasses: ["text"]
      });
    }
  }
};